module.exports = __webpack_public_path__ + "static/media/calendar.ab4c944e.svg";